import './voy-toast';
import { VoyageToast } from '../src/voy-toast';

interface ToastOptions {
  message: string;
  type: 'success' | 'error';
}

export const VoyageToastManager = new class {
  createToast({ message, type }: ToastOptions) {
    const newToast = document.createElement('voy-toast') as VoyageToast;

    newToast.message = message;
    newToast.type = type;

    // Append to the DOM
    document.body.appendChild(newToast);

    newToast.show(message, type);

    setTimeout(() => {
      newToast.remove();
    }, 3500);
  }
};
